const HomePage = () => {
	return <p>HomePage</p>;
};

export default HomePage;
